function init() {
    const contentTiles = $('.content-tiles');
    const spinnerImgUrl = contentTiles.data('spinner-img');
    const spinnerImgElement = $('<img style="margin-left:.5em; vertical-align: middle">');
    spinnerImgElement.attr('src', spinnerImgUrl);

    function loadMore() {
        var btnElement = $(this);
        var loadMoreContainer = btnElement.closest('.load-more-container');
        var page = $(this).data('page');

        // add ajax spinner to load-more button
        btnElement.off('click');
        btnElement.prop('disabled', true);
        btnElement.text($(btnElement).data('btn-loading'));
        btnElement.append(spinnerImgElement);

        // load new tiles
        $.get('/tiles-partial', {
            page,
        }).done((data) => {
            var $dv = $('<div/>').append(data);
            var imgs = $dv.find('img[src$="fake.png"]');
            var new_data;
            imgs.each(() => {
                $(this).attr('src', $(this).data('src'));
            });
            new_data = $.trim($dv.find('.content-tiles').html());
            loadMoreContainer.replaceWith(new_data);
            $(document).trigger('loaded-more');
        });
    }

    contentTiles.on('click', '.load-more', loadMore);
}

init();
